import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import moment from 'moment';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import ICTTroubleForm from './ICTTroubleForm';

import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { getSystems, getFavouriteSystems } from '../ducks';
import { isPhoneNumberValid, removeEmptyKeys } from '../../validations';

const initialValues = {
  system: '',
  requestType: null,
  topic: '',
  problemDescription: '',
  errorCode: '',
  systemCaseId: '',
  socialSecurityNumber: '',
  pcNumber: '',
  departmentCode: '',
  time: moment(),
  severity: 'LOW',
  contactPhone: '',
  othersHaveSameProblem: false,
  targetOrganization: '',
  attachmentInput: [],
  subsystem: '',
};

const ICTTrouble = props => {
  const { formId, edit } = props;
  const [externalValidations, setExternalValidations] = useState([]);
  const [systems, setSystems] = useState([]);
  const [favouriteSystems, setFavouriteSystems] = useState([]);
  const { orderId } = useParams();

  // const organizations = useSelector(state => state.reducer.organizations);

  useEffect(() => {
    const fetch = async () => {
      const systems = await getSystems();
      const favouriteSystems = await getFavouriteSystems();
      setSystems(systems);
      setFavouriteSystems(favouriteSystems);
    };

    try {
      fetch();
    } catch (e) {
      console.error('Error in fetching systems in ICT trouble form');
    }
  }, []);

  const validate = values => {
    const errors = {};

    externalValidations.forEach(validation => {
      const value = values[validation.name];
      const error = validation.getError(value);
      if (error) {
        errors[validation.name] = error;
      }
    });

    if (!values.system) {
      errors.system = 'Vaadittu';
    }

    errors.contactPhone = isPhoneNumberValid(values.contactPhone);

    // NOTE Validate SSN? Probably a bad idea as the form
    // might change in the near future.

    return removeEmptyKeys(errors);
  };

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            system: values.system.value,
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Häiriö"
          formik={formikProps}
          Component={ICTTroubleForm}
          systems={systems}
          favouriteSystems={favouriteSystems}
          hideSubmitButton={!formikProps.values.system}
          setExternalValidations={setExternalValidations}
        />
      )}
    </Formik>
  );
};

export default ICTTrouble;
